import React from "react";
import { Modal, ModalHeader, ModalBody, Progress } from "reactstrap";
import CheckBlue from '../../assets/icons/Check Blue.svg';
import Check from '../../assets/icons/Check.svg';
import AngleRight from '../../assets/icons/angle-right.svg';
import { Link } from "react-router-dom";
import { clear_auth, set_auth } from "../../reducers/Auth";
import ProgresImage from "../../assets/images/verification.png";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

class ModalProgres extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            endModal: false
        };
    }

    get_perusahaan() {
        let form = {};
        this.props.request("finish-perusahaan-guide", form, "POST")
            .then((response) => {
                if (response.success) {
                    this.props.set_auth(this.props.api_token, response.data);
                    Swal.fire({
                        text: 'Selamat menikmati fitur-fitur Presensi.co.id',
                        imageUrl: ProgresImage,
                        imageWidth: 300,
                        imageHeight: 250,
                        imageAlt: 'Custom image',
                        confirmButtonText: "selesai",
                        confirmButtonColor: "#057CE4"
                    })
                    this.props.history.push("/dashboard")
                }
            })
    }

    render() {
        const totalSteps = 6;
        let progressPercent = 0;

        if (this.props.user?.perusahaan?.perusahaan_nama !== "") progressPercent++;
        if (this.props.shift?.length > 0) progressPercent++;
        if (this.props.divisi?.length > 0) progressPercent++;
        if (this.props.karyawan?.length > 0) progressPercent++;
        if (this.props.lokasi?.length > 0) progressPercent++;
        if (this.props.jabatan?.length > 0) progressPercent++;

        const progres_value = Math.floor((progressPercent / totalSteps) * 100);

        const style = {
            info: {
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                color: "#5D6F80"
            },
            button_check: {
                width: "100%",
                padding: "17px 16px",
                backgroundColor: "#F5F5F5",
                color: "#143B5E",
            },
            button_checked: {
                width: "100%",
                padding: "17px 16px",
                backgroundColor: "#E8F4FF",
                color: "#143B5E",
                borderRadius: "8px"
            },
            text_button_checked: {
                textAlign: "left",
                paddingLeft: "10px",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px"
            },
            text_button_check: {
                textAlign: "left",
                paddingLeft: "10px",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px"
            }
        }
        return (
            <>
                <Modal isOpen={this.props.modalProgres}>
                    <ModalHeader style={{
                        backgroundColor: "#FAFDFF",
                        padding: "12px 24px"
                    }}>
                        <div style={{
                            fontSize: "24px",
                            lineHeight: "36px",
                            fontWeight: 700,
                            color: "#143B5E",
                            backgroundColor: "#FAFDFF",
                        }}>Kelengkapan Data</div>
                    </ModalHeader>
                    <ModalBody className="p-4">
                        {progres_value === 100 &&
                            <div className="row">
                                <div className="col-md-12" style={{
                                    textAlign: "center"
                                }}>
                                    <img alt="" src={ProgresImage} style={{
                                        height: "190px"
                                    }} />
                                </div>
                            </div>
                        }
                        <div className="row mt-3 d-flex flex-nowrap" style={{ paddingLeft: "14px", paddingRight: "14px" }}>
                            <div className="col-md-10 px-0">
                                <Progress style={{ height: "24px", borderRadius: "32px" }} barStyle={{ borderRadius: "32px" }} value={progres_value} />
                            </div>
                            <div className="col-md-2 pl-3 pr-0" style={{ lineHeight: "24px", fontSize: "16px", fontWeight: 500, maxWidth: "76px" }}>{progres_value}%</div>
                        </div>
                        <div className="row pt-3">
                            <div className="col-md-12" style={style.info}>
                                {progres_value !== 100 ?
                                    "Silahkan mengikuti langkah-langkah di bawah ini untuk pengisian data perusahaan Anda:"
                                    :
                                    "Selamat anda sudah berhasil menambahkan data setting awal perusahaan."
                                }
                            </div>
                        </div>
                        <div style={{
                            height: progres_value === 100 ? "215px" : "400px",
                            overflowY: "auto",
                            overflowX: "hidden"
                        }}>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="text-capitalize d-flex" style={style.button_checked}>
                                        <div className="px-0">
                                            <img alt="" src={CheckBlue} />
                                        </div>
                                        <div className="flex-fill pr-0" style={style.text_button_checked}>Kelengkapan Data Perusahaan</div>
                                    </div>
                                </div>
                            </div>
                            {this.props.shift?.length === 0 ?
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/jam-kerja"} className="btn d-flex text-capitalize" style={style.button_check} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={Check} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Jam Kerja</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                :
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/jam-kerja"} className="btn d-flex text-capitalize" style={style.button_checked} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={CheckBlue} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Jam Kerja</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            }
                            {this.props.jabatan?.length === 0 ?
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/jabatan"} className="btn d-flex text-capitalize" style={style.button_check} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={Check} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Jabatan</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                :
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/jabatan"} className="btn d-flex text-capitalize" style={style.button_checked} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={CheckBlue} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Jabatan</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            }
                            {this.props.divisi?.length === 0 ?
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/divisi"} className="btn d-flex text-capitalize" style={style.button_check} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={Check} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Divisi</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                :
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/divisi"} className="btn d-flex text-capitalize" style={style.button_checked} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={CheckBlue} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Divisi</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            }
                            {this.props.lokasi?.length === 0 ?
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/lokasi"} className="btn d-flex text-capitalize" style={style.button_check} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={Check} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Lokasi</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                :
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <Link to={"/guide/lokasi"} className="btn d-flex text-capitalize" style={style.button_checked} onClick={() => this.props.setState({ progresModal: false })}>
                                            <div className="px-0">
                                                <img alt="" src={CheckBlue} />
                                            </div>
                                            <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Lokasi</div>
                                            <div className="px-0">
                                                <img alt="" src={AngleRight} />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            }
                            {this.props.shift?.length !== 0 && this.props.divisi?.length !== 0 && this.props.lokasi?.length !== 0 && this.props.jabatan?.length !== 0 ?
                                this.props.karyawan?.length === 0 ?
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <Link to={"/guide/karyawan"} className="btn d-flex text-capitalize" style={style.button_check} onClick={() => this.props.setState({ progresModal: false })}>
                                                <div className="px-0">
                                                    <img alt="" src={Check} />
                                                </div>
                                                <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Karyawan</div>
                                                <div className="px-0">
                                                    <img alt="" src={AngleRight} />
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    :
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <Link to={"/guide/karyawan"} className="btn d-flex text-capitalize" style={style.button_checked} onClick={() => this.props.setState({ progresModal: false })}>
                                                <div className="px-0">
                                                    <img alt="" src={CheckBlue} />
                                                </div>
                                                <div className="flex-fill pr-0" style={style.text_button_check}>Tambah Karyawan</div>
                                                <div className="px-0">
                                                    <img alt="" src={AngleRight} />
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                :
                                <div></div>
                            }
                        </div>
                        {progres_value === 100 ?
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <button onClick={() => this.get_perusahaan()} className="btn btn-primary text-capitalize w-100 rounded-pill">Selesai</button>
                                </div>
                            </div>
                            :
                            <div></div>
                        }
                    </ModalBody>
                </Modal>
            </>
        )
    }
}
const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalProgres);
